import { format, subDays, subMonths } from 'date-fns'
import DefaultForm from '@/utils/defaultForm'
import { sortItems } from '@/utils/genericUtils'
import { normalizarComprobante, puedeSincronizarPago, requiereAvisoComprobante, dividirComprobantes } from '@/utils/montos'
import request from '@/utils/request'

const { formatInTimeZone } = require('date-fns-tz')
/* ## callback venta ## */
const state = {
    listaPagos: [],
    listClientPagos: [],
    external_tipoCambio: null,
    bancoTipoCambio: null
}

const getters = {}

const mutations = {
    UPDATE_LISTA_PAGOS(state, payload) {
        state.listaPagos = payload
    },
    UPDATE_EXTERNAL_TIPO_CAMBIO(state, payload) {
        state.external_tipoCambio = payload
    },
    UPDATE_EXTERNAL_BANCO_TIPO_CAMBIO(state, payload) {
        state.bancoTipoCambio = payload
    },
    UPDATE_PAGOS_CLIENT(state, payload) {
        state.listClientPagos = payload
    }
}

const actions = {
    async pagosClientes({ commit, rootState }, payload) {
        const { idSede, idBussines } = rootState.users.user
        //console.log('rootState.users.user----', rootState.users.user)

        let mainUrl
        //
        // "include": { relation: 'tm_ventas' },
        if (payload.fechaFiltro[1]) {
            const filter = { where: { and: [{ fechaPago: { between: [payload.fechaFiltro[0], payload.fechaFiltro[1]] } }, { status: 1 }] } }

            const encodedFilter = encodeURIComponent(JSON.stringify(filter))

            mainUrl = `/api-loopback/tm_pagos?filter=${encodedFilter}`
        } else {
            const filter = { where: { and: [{ fechaPago: payload.fechaFiltro[0] }, { status: 1 }] } }

            const encodedFilter = encodeURIComponent(JSON.stringify(filter))

            mainUrl = `/api-loopback/tm_pagos?filter=${encodedFilter}`
        }
        const response = await request({
            url: mainUrl,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
        console.log('response.data', response.data)

        const unique = [...new Set(response.data.map((item) => item.idVenta))] // [ 'A', 'B']
        console.log('unique', unique)
        const filter = { where: { and: [{ id: { inq: [unique] } }] } }
        const encodedFilter = encodeURIComponent(JSON.stringify(filter))

        const { data } = await request({
            url: `/api-loopback/tm_ventas?filter=${encodedFilter}`,
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        })
        let items = []
        console.log('tm_ventas', data)

        response.data.map((x) => {
            const findItem = data.find((y) => y.id == x.idVenta)
            console.log('findItem,', findItem)

            const isSede = rootState.sedes.sedes.find((y) => y.id == findItem.idSede)
            console.log('isSede,', x.idVenta, idBussines, isSede)
            if (isSede.idBussines == idBussines) {
                items.push({
                    ...x,
                    idBussines,
                    idSede: findItem.idSede,
                    nameSede: isSede.sede_name_id,
                    tipoComprobante: findItem.idTipoComprobante == 1 ? findItem.numeroComprobante : findItem.numeroComprobante
                })
            }
        })
        commit('UPDATE_PAGOS_CLIENT', items)
        console.log('tm_ventasitems', items)

        return items
    },
    async enviar_moduloPago({ commit, rootState }, payload) {
        const { atributos, id, montoDelivery, formaPago, idBussines } = payload
        const { idColaborador } = rootState.users.user
        const idFormaPago = [2, 4].includes(idBussines) ? 18 : 4
        const data = {
            idTipoMoneda: 1,
            idTipoPago: atributos.metodoPago,
            idBancoDestino: null,
            idVenta: id,
            idTipoMonedaVenta: 1,
            status: 1,
            tipoCambio: null,
            importe: montoDelivery,
            idColaborador,
            fechaPago: atributos.fechaPago,
            nroOperacion: null,
            idBancoDestinoExternal: formaPago || idFormaPago
        }
        //console.log("data---",data)
        await request({
            url: `/api-loopback/tm_pagos`,
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            data
        })
    },
    async listaPagosById({ commit, rootState }, payload) {
        // La venta que se esta mirando manda: el store puede conservar la ultima
        // venta abierta para "Editar" o para los datos de envio, y sus pagos no
        // son los de este comprobante. Sin id en el payload se mantiene el
        // comportamiento previo (paso de pagos del formulario de la venta).
        const idVenta = (payload && payload.id) || rootState.ventas.datos.id
        let data = []
        //console.log('idVenta ', idVenta)
        if (idVenta) {
            const filter = { where: { and: [{ idVenta: idVenta }, { status: 1 }] } }
            const encodedFilter = encodeURIComponent(JSON.stringify(filter))

            const response = await request({
                url: `/api-loopback/tm_pagos?filter=${encodedFilter}`,
                method: 'GET',
                headers: {
                    'content-type': 'application/json'
                }
            })
            data = response.data
            //console.log('get_Lista_pagos_from_server', data)
        } else {
            //console.log('not_id_found', data)
        }
        commit('UPDATE_LISTA_PAGOS', data)
        return data
    },
    async postPagos({ commit, rootState, dispatch }, payload) {
        // const myTimezone = formatInTimeZone(new Date(), 'America/Lima', 'yyyy-MM-dd')
        const idVenta = rootState.ventas.datos.id
        //console.log('idVenta ', idVenta)
        console.log('payload', payload)
        console.log('payload.datos (this.datos from ventas store):', payload.datos)
        console.log('payload.datos.numeroComprobante:', payload.datos.numeroComprobante)

        const { idColaborador } = rootState.users.user

        console.log({
            ...payload.body,
            fechaPago: formatInTimeZone(payload.body.fechaPago, 'America/Lima', 'yyyy-MM-dd'),
            status: 1,
            idVenta,
            idColaborador
        })
        console.log('idVenta', idVenta)
        if (idVenta) {
            const pago = await request({
                url: `/api-loopback/tm_pagos`,
                method: 'POST',
                headers: {
                    'content-type': 'application/json'
                },
                data: {
                    ...payload.body,
                    fechaPago: formatInTimeZone(payload.body.fechaPago, 'America/Lima', 'yyyy-MM-dd'),
                    status: 1,
                    idVenta,
                    idColaborador,
                    idBancoDestino: null,
                    idBancoDestinoExternal: payload.body.idBancoDestinoExternal
                }
            })
            console.log('sendPago', pago)
            await dispatch('listaPagosById', { id: payload.body.idVenta })
            
            // Check if there's a factura (numeroComprobante) to associate the payment
            const comprobante = normalizarComprobante(payload.datos.numeroComprobante)
            // Con varias facturas en la venta no se puede elegir una: el pago queda
            // solo en intranet y se avisa, en vez de asociarlo a la factura equivocada.
            const facturas = dividirComprobantes(payload.datos.numeroComprobante)
            if (facturas.length > 1) {
                const lista = facturas.join(', ')
                return {
                    sincronizado: false,
                    message:
                        `La venta tiene ${facturas.length} facturas (${lista}): el pago quedó guardado sin asociar. ` +
                        'Asociá el pago manualmente en facturación.'
                }
            }
            // Solo se sincroniza cuando el número se puede partir en serie+número;
            // los comprobantes legacy ("000136") no se tocan ni se mandan.
            const hasFactura = puedeSincronizarPago(comprobante)
            console.log('hasFactura:', hasFactura, 'numeroComprobante:', payload.datos.numeroComprobante)
            
            if (hasFactura) {
                console.log('Enviando pago a ms-migraciones para asociar con factura en facturación')
                try {
                    const response = await request({
                        url: `/ms/migraciones/v1.0/pagos?idSede=${rootState.users.user.idSede}&typeAction=${payload.typeAction}`,
                        method: 'POST',
                        headers: {
                            'content-type': 'application/json'
                        },
                        data: {
                            ...payload.datos,
                            ...payload.body,
                            numeroComprobante: comprobante,
                            userNumeroDocumento: rootState.users.user.documento,
                            fechaPago: formatInTimeZone(payload.body.fechaPago, 'America/Lima', 'yyyy-MM-dd'),
                            status: 1,
                            idVenta,
                            idColaborador,
                            idPaymentIntranet: pago.data.id
                        }
                    })
                    console.log('Response from ms-migraciones:', response.data)
                    const respuesta = response.data || {}
                    if (respuesta.codigoRespuesta != 200) {
                        // No se puede dejar pasar en silencio: el pago no quedó
                        // asociado a la factura en facturación. El aviso lo muestra
                        // el que llama, porque el modal de guardado es suyo.
                        return {
                            sincronizado: false,
                            message: respuesta.message || 'No se pudo registrar el pago en facturación'
                        }
                    }
                    return { sincronizado: true, message: null }
                } catch (error) {
                    console.error('Error enviando pago a ms-migraciones:', error)
                    return {
                        sincronizado: false,
                        message: 'No se pudo contactar a facturación: el pago quedó guardado sin asociar al comprobante'
                    }
                }
            } else {
                console.log('No se envía a facturación porque no hay factura (numeroComprobante)')
                // Un comprobante guardado que no se puede partir es una anomalía:
                // hay que decirlo, no cerrar el modal como si hubiera sincronizado.
                // Los marcadores sin factura ("SN", "NO FACTURAR") no avisan.
                if (requiereAvisoComprobante(payload.datos.numeroComprobante)) {
                    return {
                        sincronizado: false,
                        message: `El comprobante guardado ("${payload.datos.numeroComprobante}") no permite identificar la factura: el pago quedó sin asociar. Verificá el número de comprobante de la venta.`
                    }
                }
            }
            return { sincronizado: false, message: null }
        }
        return { sincronizado: false, message: null }
    },
    async deletePagos({ commit, rootState, dispatch }, payload) {
        let data = []
        console.log('payload', payload)
        if (payload.item.id) {
            const response = await request({
                url: `/api-loopback/tm_pagos/${payload.item.id}`,
                method: 'PUT',
                headers: {
                    'content-type': 'application/json'
                },
                data: {
                    ...payload.item,
                    status: 0
                }
            })

            const hasFactura = puedeSincronizarPago(normalizarComprobante(payload.datos && payload.datos.numeroComprobante))
            // Anular el pago en intranet cuando la venta acumula varias facturas deja
            // el pago vivo en facturación: hay que decirlo, no cerrar en silencio.
            const facturas = dividirComprobantes(payload.datos && payload.datos.numeroComprobante)
            if (facturas.length > 1) {
                const lista = facturas.join(', ')
                commit(
                    'mainUI/OPEN_MODAL',
                    {
                        state: true,
                        close: true,
                        text:
                            `El pago se anuló en la intranet, pero la venta tiene ${facturas.length} facturas (${lista}) ` +
                            'y no se pudo identificar cuál anular en facturación. Revisá el pago manualmente.'
                    },
                    { root: true }
                )
            } else if (hasFactura) {
                const respuesta = await request({
                    url: `/ms/migraciones/v1.0/pagos?idSede=${rootState.users.user.idSede}&typeAction=2`,
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    data: {
                        ...payload.datos,
                        ...payload.body,
                        ...payload.item,
                        numeroComprobante: normalizarComprobante(payload.datos && payload.datos.numeroComprobante),
                        fechaPago: formatInTimeZone(payload.item.fechaPago, 'America/Lima', 'yyyy-MM-dd'),
                        idVenta: payload.item.idVenta,
                        idColaborador: payload.item.idColaborador,
                        idPaymentIntranet: payload.item.id
                    }
                })
                const body = respuesta.data || {}
                if (body.codigoRespuesta != 200) {
                    // `root: true` porque este módulo es namespaced: sin él, Vuex
                    // busca 'pagos/mainUI/OPEN_MODAL' y el aviso no se muestra.
                    commit(
                        'mainUI/OPEN_MODAL',
                        {
                            state: true,
                            close: true,
                            text: body.message || 'No se pudo eliminar el pago en facturación'
                        },
                        { root: true }
                    )
                }
            }

            await dispatch('listaPagosById', { id: payload.item.idVenta })
        } else {
            //console.log('not_id_found', data)
        }
    },
    async tipoCambio({ commit, state, rootState, dispatch }, payload) {
        try {
            if (!state.external_tipoCambio) {
                const { data } = await request({
                    url: `/ms/servicios/pk/v1.1/tipoCambio`,
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                })
                //console.log('UPDATE_EXTERNAL_TIPO_CAMBIO', data.data.venta)
                commit('UPDATE_EXTERNAL_TIPO_CAMBIO', data.data.venta)
            }
        } catch (error) {
            console.log('Ocurrio un error con el Api')
            commit('UPDATE_EXTERNAL_TIPO_CAMBIO', null)
        }
    },
    async bancoTipoCambio({ commit, state, rootState, dispatch }, payload) {
        try {
            console.log('tipocambio', state.bancoTipoCambio)
            if (!state.bancoTipoCambio) {
                const { data } = await request({
                    url: `/ms/datosperu/v1.1/tipoCambio`,
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json'
                    }
                })
                console.log('data', data)
                commit('UPDATE_EXTERNAL_BANCO_TIPO_CAMBIO', data.venta)
            }
        } catch (error) {
            commit('UPDATE_EXTERNAL_BANCO_TIPO_CAMBIO', null)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
